const Keyword = function(props) {
	let {found, word, status, removeCallback} = props;
	let classes = `keyword-item ${status}`;

	return (
		<li className={classes}>{word} ({found}) <button className="keyword-remove" data-word={word} onClick={removeCallback} title={window?.t?.REMOVE_FROM_LIST}>×</button></li>
	)
}
export default Keyword;